// extracted by mini-css-extract-plugin
export default {"logoTitle":"header_logo_title-module__logoTitle--17dYF"};